<template>
    <Layout>
        <template #title v-if="data">
            <OverviewTitle>
                <template v-slot:title(head)>{{ $t('buyer') }}</template>
                <template v-slot:title>{{ data.name }}</template>
                <template v-slot:title(foot)>{{ $filters.upper($t('organization_id')) }}: {{ data.ico }}</template>
            </OverviewTitle>
        </template>

        <template #nav>

        </template>

        <template #main>
            <Loader v-if="isBusy" />
        </template>
    </Layout>
</template>

<script>
import Layout from "@/views/layouts/Basic.vue";
import Loader from "@/components/Loader.vue";
import OverviewTitle from "@/components/OverviewTitle.vue";

export default {
    props: {
        hash: { required: true }
    },
    name: "analysis-overview",
    components: { Layout, Loader, OverviewTitle },
    mounted: function () {
        this.loadData()
    },
    data: function () {
        return {
            data: null,
            isBusy: false
        }
    },
    computed: {
    },
    methods: {
        loadData: function () {
            this.isBusy = true

            var self = this

            var params = {
                format: "json",
                full_hash: this.hash
            }

            return this.$store.getters.api
                .get("analysis/", { params: params })
                .then(response => {
                    self.data = response.data.data[0]
                })
                .catch(e => {
                    console.dir(e)
                    self.data = null
                })
                .finally(() => this.isBusy = false)
        }
    }
};
</script>

<style scoped lang="scss">
#perPageSelect {
    width: 70px;
}
</style>